import { CheckboxGroup } from "@heroui/react";
import { CustomCheckbox } from "../CustomCheckbox";

type Props = {
  singlesOrDoubles: ("singles" | "doubles" | "tiebreak")[];
  setSinglesOrDoubles: (
    formats: ("singles" | "doubles" | "tiebreak")[]
  ) => void;
};

export function SinglesOrDoublesFilter(props: Props) {
  const { singlesOrDoubles, setSinglesOrDoubles } = props;

  return (
    <CheckboxGroup
      className="gap-1"
      orientation="horizontal"
      value={singlesOrDoubles}
      onChange={setSinglesOrDoubles}
    >
      <CustomCheckbox value="singles">Singles</CustomCheckbox>
      <CustomCheckbox value="doubles">Doubles</CustomCheckbox>
      <CustomCheckbox value="tiebreak">Tiebreak</CustomCheckbox>
    </CheckboxGroup>
  );
}
